import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { useForm, useFieldArray } from 'react-hook-form';
import { Button } from 'react-bootstrap';
import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
import { useEffect } from 'react';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaTimes } from 'react-icons/fa';

const AddEmployeeLevel = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [parents, setParents] = useState([]);
  const [childrens, setChildrens] = useState([]);
  const { employeeLevel } = useSelector((state) => state.employeeLevel);
  const { register, control, setValue, handleSubmit, reset } = useForm({
    defaultValues:
      employeeLevel && id
        ? {
            title: employeeLevel.title
            // parent: employeeLevel.parent
          }
        : {}
  });
  const { fields, append, remove } = useFieldArray({
    name: 'subcategory',
    control
  });
  useEffect(() => {
    if (id && employeeLevel) setChildrens(employeeLevel.childrens);
  }, [id, employeeLevel]);
  useEffect(() => {
    if (!id) {
      append({});
    }
  }, [id, append]);

  useEffect(() => {
    const getParents = async () => {
      const response = await fetchWrapper.get('/employee-type/');
      setParents(response.data.results.map((item) => ({ value: item.id, label: item.title })));
    };
    getParents();
  }, []);

  const onSubmit = async (data) => {
    try {
      const body = {
        title: data.title,
        parent: data.parent,
        children: data.children
      };
      if (id) {
        await fetchWrapper.patch(`/employee-type/${id}/`, body);
      } else {
        await fetchWrapper.post('/employee-type/', body);
      }
      toast.success(<FormattedMessage id="employee_type_created" />);
      reset();
      navigate('/admin/settings/employee_type_level');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const deleteChildren = async (index, field) => {
    try {
      if (field._id) {
        await fetchWrapper.delete(`/employee-type/${field._id}/`);
      }
      remove(index);
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const deleteSubCategory = async (id) => {
    try {
      await fetchWrapper.delete(`/employee-type/${id}/`);
      setChildrens((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  return (
    <div className="card content-section p-3">
      <div className="d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <FormattedMessage id="employee_type_level" />
        </h4>
      </div>
      <hr />
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-md-6">
              {!id && (
                <FormGroup
                  id="parent"
                  type="select"
                  register={register}
                  label={<FormattedMessage id="participant_type" />}
                  options={parents}
                  onChange={(value) => {
                    setValue('parent', value.value);
                  }}
                />
              )}
              <FormGroup
                id="title"
                type="text"
                register={register}
                label={<FormattedMessage id="category" />}
              />
            </div>
            {id && (
              <div className="col-md-6">
                <p className="fw-bold">
                  <FormattedMessage id="sub_category" />
                </p>
                {childrens.map((child) => (
                  <div
                    key={child.id}
                    className="d-flex align-items-center justify-content-between w-25">
                    <p>{child.title}</p>
                    <FaTimes
                      className="text-danger cursor-pointer"
                      onClick={() => deleteSubCategory(child.id)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-md-6">
              {fields.map((field, index) => (
                <div className="d-flex align-items-center" key={field.id}>
                  <FormGroup
                    id={`children[${index}]`}
                    type="text"
                    register={register}
                    label={<FormattedMessage id="sub_category" />}
                    defaultValue={field?.title && field.title}
                  />
                  <div className="h-100 d-flex justify-content-center align-items-center">
                    <FaTimes
                      className="text-danger cursor-pointer m-2"
                      onClick={() => deleteChildren(index, field)}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-end align-items-start">
              <Button variant="primary" onClick={() => append({})}>
                Add
              </Button>
            </div>
          </div>
          <div className="d-flex mt-3">
            <Button
              variant="danger"
              className="me-2"
              onClick={() => navigate('/admin/settings/employee_type_level/')}>
              <FormattedMessage id="button.cancel" />
            </Button>
            <SubmitBtn
              // isLoading={isLoading}
              buttonText={<FormattedMessage id="button.save" />}
              icon="none"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployeeLevel;
